import { TranslationService } from "projects/dop-core/src/public-api";

export class AdvanceSearchLabels {
    advancedSearchLabel?: string;
    testInstructionsLabel?: string;
    descriptionLabel?: string;
    appliedOnLabel?: string;
    objectiveLabel?: string;
    methodLabel?: string;
    parameterCodeLabel?: string;
    parameterNameLabel?: string;
    CASNumberLabel?: string;
    alsoSearchOnLabel?: string;
    refineSearchLabel?: string;
    clearAllLabel?: string;
    combineSearchOnLabel?: string;

    constructor() {
        this.advancedSearchLabel = TranslationService.translate('vbeiAdvancedSearch');
        this.testInstructionsLabel = TranslationService.translate('vbeiTestInstructions');
        this.descriptionLabel = TranslationService.translate('vbeiDescription');
        this.appliedOnLabel = TranslationService.translate('vbeiAppliedOn');
        this.objectiveLabel = TranslationService.translate('vbeiObjective');
        this.parameterCodeLabel = TranslationService.translate('vbeiParameterCode');
        this.parameterNameLabel = TranslationService.translate('vbeiParameterName');
        this.methodLabel = TranslationService.translate('vbeiMethodAOAC​');
        this.CASNumberLabel = TranslationService.translate('vbeiCASNumber');
        this.alsoSearchOnLabel = TranslationService.translate('vbeiAlsoSearchOn');
        this.refineSearchLabel = TranslationService.translate('vbeiRefineSearch');
        this.clearAllLabel = TranslationService.translate('vbeiClearAll');
        this.combineSearchOnLabel = TranslationService.translate('vbeiCombineSearchOn');
    }
}
